import React from 'react'
import '../../css/BisharatMain.css';





const Tree = ({ data = [] }) => {
    return (
        <div className="tree">
            <table className="tree tree-table">

                <ul>
                    {data.map(tree => (
                        <TreeNode node={tree} key={tree.id} />
                    ))}
                </ul>

            </table>
        </div>
    )
}


const TreeNode = ({ node }) => {

 

    const gender = (node.gender === "male") ? 'male' : 'female';
    const hasChildren = Object.keys(node.children).length !== 0;
   

    const showMember = (memberid) => {

        window.open(`/family-members/${memberid}`, '_self');
        // window.location.href = `/family-members/${memberid}`;
    }

    return (

        <li>
        {gender === "male" ? 
           <button className="btn-tree" onClick={() => showMember(node.id)}>{node.name}</button> :
           <button className="btn-tree-female" onClick={() => showMember(node.id)}>{node.name}</button>
       }    

        {hasChildren &&
        <Tree data={node.children} /> 
        }
            
        </li>


    )
}


export default Tree
